<template>
  <div v-if="role === 1" class="up">
    <el-tooltip
      effect="dark"
      placement="top"
      :content="$t('controller.升级为主播')"
      :visible-arrow="false"
    >
      <span class="cursor-pointer up-host" @click="openUpHost = true">
        <i class="icon-up"></i>
      </span>
    </el-tooltip>
    <UpHost :visible.sync="openUpHost" />
  </div>
</template>
<script>
import UpHost from '@/components/upHost/upHost.vue';
export default {
  name: 'up',
  data() {
    return {
      openUpHost: false
    };
  },
  components: {
    UpHost
  },
  computed: {
    role() {
      //3:主播 2：助手 1：嘉宾
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type;
    }
  },
  watch: {
    role(n) {
      if (n!=1) {
        this.openUpHost = false
      }
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.up {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 18px;
}
.up-host {
  display: flex;
}
.icon-up {
  width: 20px;
  height: 20px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../svg/up_host.svg');
}
[data-theme='Orange'] .icon-up {
    background-image: url('../../svg/up-host-yellow.svg');
}
</style>
